import { post, get } from './http'
let tokenPromise
const user = {
    getToken(data) {
        if(!tokenPromise){
            tokenPromise= post('css-uaa/auth/clientToken', data).then((data) => {
                localStorage.setItem('lbs-token', data)
                return data
            })
        }
        return tokenPromise
    },
    // 通过城市、位置获取门店
    getAll(data) {
        return post('css-employee/branchDrainage/getAll', data)
    },
    // 获取所有 es 大陆门店
    getEs(data) {
        return post('css-employee/branchDrainage/getEs', data)
    },
    // 获取所有 css 大陆门店
    getCss(data) {
        return post('css-employee/branchDrainage/getCss', data)
    },
    // 获取所有 mg 大陆门店
    getMg(data) {
        return post('css-employee/branchDrainage/getMg', data)
    },
    // 获取所有 pro 大陆门店
    getPro(data) {
        return post('css-employee/branchDrainage/getPro', data)
    },
    // 获取所有 css mg 大陆门店
    getCssMg(data) {
        return post('css-employee/branchDrainage/getCssMg', data)
    },
    // 获取所有 css mb 大陆门店
    getCssMb(data) {
        return post('css-employee/branchDrainage/getCssMb', data)
    },
    // 获取所有 css pro 大陆门店
    getCssPro(data) {
        return post('css-employee/branchDrainage/getCssPro', data)
    },
    // 获取所有 css mg pro 大陆门店
    getCssMgPro(data) {
        return post('css-employee/branchDrainage/getCssMgPro', data)
    },
    // 获取所有 css mg pro 大陆门店
    getCssMbPro(data) {
        return post('css-employee/branchDrainage/getCssMbPro', data)
    },
    // 获取所有大陆门店
    getAllInland(data) {
        return post('css-employee/branchDrainage/getAllInland', data)
    },
    // 通过城市、位置获取 area 中的门店
    getByArea(data) {
        return post('css-employee/branchDrainage/getByArea', data)
    },
    getProvinceAndCity(data) {
        return post('css-employee/branchDrainage/getProvinceAndCity', data)
    },
    queryByOrgCode(data) {
        return post(`/css-employee/branchDrainage/queryByOrgCode/${data}`)
    },
    // 提交微信用户信息
    saveWeixinUser(data) {
        return post('/css-customer/lbs/saveWechatUserInfo', data)
    }
}
export default user
